import { stateTree } from 'modules/data';
import { createAction, ExtractActions } from 'modules/react-redux';

export const LOAD_PAGE_DATA = 'WORKFLOWS_LIST/LOAD_PAGE_DATA';
export const loadPageData = (companyId: string, entities: Partial<stateTree.Entities> = {}) =>
    createAction(LOAD_PAGE_DATA, { companyId, entities });

export type Action = ExtractActions<typeof loadPageData>;
